'use client'

import { colors } from '@lib/colors/colors'
import { LiveAudioVisualizer } from 'react-audio-visualize'

const AudioVisualizer = ({
  height = 110,
  mediaRecorderInstance,
  width = 255,
}: {
  height?: number
  mediaRecorderInstance: MediaRecorder
  width?: number
}) => {
  return (
    <LiveAudioVisualizer
      backgroundColor={colors.primary200}
      barColor={colors.primary400}
      barWidth={8}
      fftSize={128}
      height={height}
      mediaRecorder={mediaRecorderInstance}
      smoothingTimeConstant={0.9}
      width={width}
    />
  )
}

export default AudioVisualizer
